module.exports = __webpack_public_path__ + "static/media/torch.acb49d0b.svg";